import React, { useEffect } from "react";
// import studentsImage from "../Assets/workspace.png";
import "../Stylesheets/BenefitsSection.css";
import AOS from "aos";

const BenefitsSection = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
    window.scrollTo({ behavior: "smooth", top: 0 });
  }, []);
  // const physicalBenefits = [
  //   {
  //     icon: "💻",
  //     title: "Premium Laptop",
  //     description: "High-performance laptop for your entire learning journey",
  //   },
  //   {
  //     icon: "📓",
  //     title: "Learning Materials",
  //     description: "Comprehensive notepad and stationery kit",
  //   },
  //   {
  //     icon: "🖊️",
  //     title: "Writing Tools",
  //     description: "Professional pens and writing materials",
  //   },
  // ];

  const digitalBenefits = [
    {
      icon: "🚀",
      title: "Project-Based Learning",
      description: "Work on real-world projects to strengthen your portfolio",
    },
    {
      icon: "🌐",
      title: "Community Access",
      description:
        "Collaborate and network with peers in an active learning community",
    },
    {
      icon: "📚",
      title: "Learning Platforms",
      description:
        "Guidance on handling multiple open source platforms",
    },
  ];

  const programBenefits = [
    {
      icon: "👨‍🏫",
      title: "Expert Mentorship",
      description: "One-on-one guidance from industry professionals",
    },
    {
      icon: "📊",
      title: "Weekly Evaluations",
      description: "Regular progress assessments and feedback",
    },
    {
      icon: "✅",
      title: "Performance Tracking",
      description: "Structured learning schedule with performance monitoring",
    },
    {
      icon: "🚀",
      title: "Project Guidance",
      description: "Step-by-step mentoring to build real-world IT projects",
    },
  ];

  const renderBenefitCard = (benefit, index, type) => (
    <div
      className={`col-md-${type === "program" ? "6 col-lg-3" : "4"}`}
      key={index}
      style={{ marginBottom: "px" }}
    >
      <div
        className="benefit-card h-100 text-center p-4"
        onClick={() => console.log(`Learn more about ${benefit.title}`)}
      >
        <div className="benefit-icon mb-4">{benefit.icon}</div>
        <h4 className="fw-semibold mb-3" style={{ fontStyle: "oblique" }}>
          {benefit.title}
        </h4>
        <p className="benefit-text mb-2">{benefit.description}</p>
      </div>
    </div>
  );

  return (
    <section
      className="py-5 position-relative text-white"
      id="benefits-section"
    >
      {/* Background Gradient */}
      <div
        className="position-absolute top-0 start-0 w-100 h-100"
        style={{
          background: "linear-gradient(180deg, black, #243b55, black)",
          zIndex: -1,
        }}
      />

      <div className="container">
        {/* Section Header */}
        <div className="text-center d-flex flex-column align-items-center">
          <h1
            className="display-5 my-3 gradient-text"
            style={{ fontFamily: "'Merriweather', serif", fontWeight: "800" }}
          >
            What You'll Get
          </h1>
          <h2 className="display-6 fw-bold" data-aos="fade-up">
            Everything You Need to Succeed
          </h2>
          <p
            className=" fs-5 my-4 "
            style={{ maxWidth: "85%", lineHeight: "1.5" }}
          >
            We provide comprehensive support including physical resources,
            digital access, and professional guidance throughout your 6-month internship
            journey.
          </p>
        </div>

        {/* Hybrid Learning Section */}
        <div className="row align-items-center mb-5">
          {/* <div className="col-lg-6 mb-4 mb-lg-0">
            <img
              src="https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img15030_IMG.png"
              alt="Students learning coding"
              className="img-fluid rounded shadow-lg"
            />
          </div> */}
        </div>

        {/* Physical Benefits */}
        {/* <div className="mb-5">
          <h3 className="h3 fw-bold text-center mb-5 ">Physical Resources</h3>
          <div className="row g-4" data-aos="flip-down">
            {physicalBenefits.map((benefit, index) =>
              renderBenefitCard(benefit, index, "physical")
            )}
          </div>
        </div> */}

        {/* <div className="d-flex align-items-center flex-column">
          <h2 className="h3 fw-bold mb-3 text-center">
            Hybrid Learning Experience
          </h2>
          <p className="text-center fs-5" style={{ maxWidth: "85%" }}>
            Our unique hybrid learning model combines self-paced online learning
            with in-person mentorship and guidance at our ELCOT IT SEZ facility
            in Madurai. Experience the best of both worlds with flexibility and
            direct support.
          </p>
        </div> */}

        {/* Digital Benefits */}
        <div className="my-5">
          <h3 className="h3 fw-bold text-center  mb-5">Digital Access</h3>
          <div className="row g-4" data-aos="flip-down">
            {digitalBenefits.map((benefit, index) =>
              renderBenefitCard(benefit, index, "digital")
            )}
          </div>
        </div>

        {/* Program Benefits */}
        <div>
          <h3 className="h3 fw-bold text-center  mb-5">Program Support</h3>
          <div className="row g-4" data-aos="flip-down">
            {programBenefits.map((benefit, index) =>
              renderBenefitCard(benefit, index, "program")
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
